import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import SettingsService from '../Core/Services/SettingsService';

const pluginUrl = SettingsService.getPluginUrl();
function detectLanguageFromTld() {
  var language = SettingsService.getLanguage();

  // Check if a lang param is present in the URL and use it if available
  const urlParams = new URLSearchParams(window.location.search);
  const langParam = urlParams.get('lang');
  if (langParam) {
    return langParam;
  }
  return language;
}

i18n
  .use(initReactI18next)
  .use(HttpApi)
  .init({
    lng: detectLanguageFromTld(),
    fallbackLng: 'en',
    debug: false,
    backend: {
      loadPath: `${pluginUrl}/locales/{{lng}}/translation.json`,
    },
    interpolation: {
      escapeValue: false,
    },
  });
export default i18n;
